import { render, staticRenderFns } from "./circulars-academics.vue?vue&type=template&id=57baed42&scoped=true&"
import script from "./circulars-academics.vue?vue&type=script&lang=js&"
export * from "./circulars-academics.vue?vue&type=script&lang=js&"
import style0 from "./circulars-academics.vue?vue&type=style&index=0&id=57baed42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57baed42",
  null
  
)

export default component.exports